export default "__VITE_ASSET__C5F8FLqP__"